import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'
import { heading2 } from '../../../../../../app/sofia/resources/theme/css'

export const IconWrapper = styled.div<any>`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${props => props.theme.palette.primary.alphaDark};
  margin: 25px 0 20px 10px;
  min-width: 100px;

  span {
    margin-left: 4px;
    font-size: 14px;
  }

  ${props => !props.isSofia && `
    svg {
      #Size {
        fill: ${props.theme.palette.primary.alphaDark};
      }
    }
  `}
`

export const SizingChartContent = styled.div`
  table {
    border-collapse: collapse;
    margin: auto;
    ${bp('sm')`
      width: 100%;
      display: flex;
      justify-content: center;
    `}

    thead {
      td {
        font: ${font('default', 'bold', '14px/1.5')};
      }
    }

    tbody {
      tr {
        td {
          ${bp('sm')`
            position: relative;

            &::after {
              content: '';
              width: 1px;
              position: absolute;
              top: 10px;
              bottom: 10px;
              left: 0;
              background: ${(props: any) => props.theme.palette.general.grey};
            }
          `}
        }
      }
    }

    td {
      padding: 15px;

      &:not(:first-child) {
        border: 1px solid ${props => props.theme.palette.general.greyDark};
        text-align: center;
        ${bp('sm')`
          border-width: 0 0 1px 0;
          box-sizing: border-box;
          height: 70px;
          display: flex;
          flex-direction: column;
          text-align: left;
          font-size: 18px;
          padding: 10px;

          &::before {
            content:attr(data-mobile-title);
            font-size: 14px;
            color: ${(props: any) => props.theme.palette.general.grey};
          }
        `}
      }

      &:first-child {
        ${bp('sm')`
          display: none;
        `}
      }
    }

    tr {
      ${bp('sm')`
        display: flex;
        flex-direction: column;
      `}
    }
  }

  h2 {
    ${heading2}
    font-size: 20px;
    text-align: center;
  }

  h4 {
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 0;
  }

  .bottom-block {
    margin-top: 20px;
    ${bp('sm')`
      margin-top: 30px;
    `}

    .columns-2 {
      display: flex;
      ${bp('sm')`
        flex-wrap: wrap;
      `}

      > div {
        width: 50%;
        margin: 0 5px;
        display: flex;
        flex-direction: column;
        ${bp('sm')`
          width: 100%;
        `}

        img {
          max-width: 100%;
          margin-top: auto;
        }
      }
    }
  }
`
